import { gql } from "@apollo/client/core";

export const ORGANIZATION_INFO_QUERY = gql`
  query ClientInfoQuery {
    organizationConfig {
      id
      name
      logoHash
      theme
    }
  }
`;
